import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PROJECT_AGENT_APPROVAL,
  PROJECT_AGENT_CHAT,
  PROJECT_AGENT_THREAD,
  PROJECT_AGENT_THREADS,
  PROJECT_API_KEY
} from 'src/@core/services/util/api.endpoints';
import { AgentChatResponse, AgentThreadResponse, AgentThreadSummary } from './project-agent.types';

/** Scope the agent works in. The server re-checks it on every call. */
export interface AgentScope {
  entityId: string;
  projectId: string;
}

export interface AgentUser {
  userId: string;
  userName: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectAgentService {

  constructor(private http: HttpClient) { }

  private headers(): HttpHeaders {
    return new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
  }

  /** Send a message. Omit threadId to start a new conversation. */
  send(scope: AgentScope, user: AgentUser, message: string, threadId?: string): Observable<AgentChatResponse> {
    return this.http.post<AgentChatResponse>(PROJECT_AGENT_CHAT, {
      ...scope,
      ...user,
      message,
      threadId: threadId || ''
    }, { headers: this.headers() });
  }

  getThread(scope: AgentScope, threadId: string): Observable<AgentThreadResponse> {
    const params = new HttpParams()
      .set('entity_id', scope.entityId)
      .set('project_id', scope.projectId)
      .set('thread_id', threadId);
    return this.http.get<AgentThreadResponse>(PROJECT_AGENT_THREAD, { headers: this.headers(), params });
  }

  listThreads(scope: AgentScope): Observable<{ threads: AgentThreadSummary[] }> {
    const params = new HttpParams()
      .set('entity_id', scope.entityId)
      .set('project_id', scope.projectId);
    return this.http.get<{ threads: AgentThreadSummary[] }>(PROJECT_AGENT_THREADS, { headers: this.headers(), params });
  }

  /** Approve or reject a change the agent proposed. */
  decide(scope: AgentScope, user: AgentUser, threadId: string, approvalId: string,
         decision: 'approve' | 'reject'): Observable<{ status: string; decision: string }> {
    return this.http.post<{ status: string; decision: string }>(PROJECT_AGENT_APPROVAL, {
      ...scope,
      ...user,
      threadId,
      approvalId,
      decision
    }, { headers: this.headers() });
  }
}
